module.exports = __webpack_public_path__ + "img/grey_048.111b585c.png";